let routes = [{
    path: '/',
    name: '康护佳公共服务',
    component: () => import('../components/child_router_view'),
    children: [
        {
            path: '/service',
            name: '服务列表',
            meta:{
                type:'2'
            },
            component: () => import('../components/kanghujia/service_list')
        },{
            path: '/service-self',
            name: '自营服务列表',
            meta:{
                type:'3'
            },
            component: () => import('../components/kanghujia/service_list')
        },
        {
            path: '/service-category',
            name: '服务分类',
            meta:{
                type:'4'
            },
            component: () => import('../components/category/list.vue')
        },
        {
            path: '/service-order',
            name: '公共服务订单',
            meta:{
                type:'0',
                categoryType:'4',
                serviceType:'2'
            },
            component: () => import('../components/schedule/list')
        },{
            path: '/service-self-order',
            name: '自营服务订单',
            meta:{
                type:'1',
                categoryType:'4',
                serviceType:'2'
            },
            component: () => import('../components/schedule/list')
        },
        {
            path: '/service-form',
            name: '表单管理',
            component: () => import('../components/kanghujia/service_form')
        },
        {
            path: '/station',
            name: '服务站点',
            meta:{
                type:'6'
            },
            component: () => import('../components/agent/list')
        },
        {
            path: '/add-service',
            name: '新建服务',
            meta:{
                type:'2'
            },
            component: ()=>import('../components/kanghujia/service_add'),
            hideMenu:true
        },
        {
            path: '/add-service-self',
            name: '新建自营服务',
            meta:{
                type:'3'
            },
            component: ()=>import('../components/kanghujia/service_add'),
            hideMenu:true
        },
        {
            path: '/add-form',
            name: '创建表单',
            component: () => import('../components/kanghujia/service_form_add'),
            hideMenu:true
        },
        {
            path: '/add-station',
            name: '新建站点',
            meta:{
                type:'6'
            },
            component: () => import('../components/agent/add'),
            hideMenu:true
        },
        {
            path: '/serviser',
            name: '服务人员',
            component: () => import('../components/kanghujia/servicer_list'),
            hideMenu:true
        },
        {
            path: '/subscribe', 
            name: '公共服务排期',
            meta:{
                type:'6',
                categoryType:'4',
                serviceType:'2'
            },
            component: () => import('../components/schedule/subscribe'),
            hideMenu:true
        },
        {
            path: '/subscribe-self', 
            name: '自营服务排期',
            meta:{
                type:'6',
                categoryType:'4',
                serviceType:'3'
            },
            component: () => import('../components/schedule/subscribe'),
            hideMenu:true
        },
        {
            path: '/related-form',
            name: '关联表单',
            component: () => import('../components/schedule/related_form_list'),
            hideMenu:true
        },
    ]
},
{
    path: '/',
    name: '会员管理',
    component: () => import('../components/child_router_view'),
    children:[
        {
            path: '/add-fields', 
            name: '自定义字段',
            component: () => import('../components/seller/fields'),
        },
        {
        path: '/add-seller', 
        name: '新建会员',
        component: () => import('../components/seller/add'),
        hideMenu:true
    }],
},
{
    path: '/service-order-sta',
    name: '公共服务订单统计',
    meta:{
        serviceType:0
    },
    component: () => import('../components/schedule/statistics'),
    children:[
        {
            path: '/service-order-sta-date',
            name: '片区订单日报',
            meta:{
                serviceType:0
            },
            component: () => import('../components/schedule/statistics-date')
        },
        {
            path: '/service-order-sta-month',
            name: '片区订单月报',
            meta:{
                serviceType:0
            },
            component: () => import('../components/schedule/statistics-month')
        },
        {
            path: '/service-order-sta-seller',
            name: '客户订单统计',
            meta:{
                serviceType:0
            },
            component: () => import('../components/schedule/statistics-seller')
        },
        {
            path: '/service-order-sta-waiter',
            name: '服务人员订单统计',
            meta:{
                serviceType:0
            },
            component: () => import('../components/schedule/statistics-waiter')
        },
    ]
},
{
    path: '/service-self-order-sta',
    name: '自营服务订单统计',
    meta:{
        serviceType:1
    },
    component: () => import('../components/schedule/statistics'),
    children:[
        {
        path: '/service-self-order-sta-date',
        name: '片区订单日报',
        meta:{
            serviceType:1
        },
        component: () => import('../components/schedule/statistics-date')
    },
    {
        path: '/service-self-order-sta-month',
        name: '片区订单月报',
        meta:{
            serviceType:1
        },
        component: () => import('../components/schedule/statistics-month')
    },
    {
        path: '/service-self-order-sta-seller',
        name: '客户订单统计',
        meta:{
            serviceType:1
        },
        component: () => import('../components/schedule/statistics-seller')
    },
    {
        path: '/service-self-order-sta-waiter',
        name: '服务人员订单统计',
        meta:{
            serviceType:1
        },
        component: () => import('../components/schedule/statistics-waiter')
    },]
}];

export default routes;


// WEBPACK FOOTER //
// ./src/router/kanghujia.js